import {
  ApiRemoveGiftCardFromCartFailedAction,
  ApiRemoveGiftCardFromCartSucceededAction,
  apiRemoveGiftCardFromCartFailedType,
  apiRemoveGiftCardFromCartRequested,
  apiRemoveGiftCardFromCartSucceededType
} from '@spa/lib/store/api/cart/removeGiftCardFromCartApi';
import {
  RemoveGiftCardFromCartRequestedAction,
  removeGiftCardFromCartFailed,
  removeGiftCardFromCartSucceeded
} from '../../carts/cartsSlice';
import { put, race, take } from 'typed-redux-saga';
import convertCartToStateCart from '@spa/lib/converters/convertCartToStateCart';
import generateActionId from '../../../generateActionId';

function* removeGiftCardFromCartSaga({
  payload: { actionId: requestedActionId, cartId }
}: RemoveGiftCardFromCartRequestedAction): Generator {
  const actionId: number = generateActionId();

  yield* put(
    apiRemoveGiftCardFromCartRequested({
      actionId,
      cartId,
      parentActionId: requestedActionId
    })
  );

  let isSameActionId: boolean = false;
  do {
    const { succeeded, failed } = yield* race({
      succeeded: take<ApiRemoveGiftCardFromCartSucceededAction>(
        apiRemoveGiftCardFromCartSucceededType
      ),
      failed: take<ApiRemoveGiftCardFromCartFailedAction>(apiRemoveGiftCardFromCartFailedType)
    });

    isSameActionId =
      succeeded?.payload.requestedActionId === actionId ||
      failed?.payload.requestedActionId === actionId;

    if (isSameActionId) {
      if (succeeded !== undefined) {
        const cart = succeeded.payload.result?.cart;

        yield* put(
          removeGiftCardFromCartSucceeded({
            cart: cart ? convertCartToStateCart(cart) : null,
            requestedActionId
          })
        );
      } else if (failed !== undefined) {
        yield* put(
          removeGiftCardFromCartFailed({
            requestedActionId
          })
        );
      }
    }
  } while (!isSameActionId);
}

export default removeGiftCardFromCartSaga;
